import { useQuery } from 'react-query'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { isEmpty } from 'lodash'

export const useGetSalePathsImpressions = ({
  filters,
}: {
  filters?: Record<string, unknown>
}) => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)
  return useQuery(
    [
      'dealership',
      dealership?.id,
      'performance',
      'sale-paths',
      'impressions',
      queryParams,
    ],
    () =>
      request<{
        data: Array<any>
        insights: {
          topSites: Array<{
            label: string
            people: number
          }>
          campaignImpressions: Array<{ label: string; value: number }>
          deviceImpressions: Array<{ label: string; value: number }>
          campaignSales: Array<{
            label: string
            value: number
          }>
          audienceSales: Array<{
            label: string
            value: number
          }>
          vendorCampaignSales: Array<{
            label: string
            value: number
          }>
          uniqueDevicesPerConversion: number
          mostEfficientDevice: { deviceType: string; avgImpressions: number }
          uniqueSitesPerConversion: number
          mostEfficientSite: {
            site: string
            avgImpressions: number
          }
          shortestConversionTimeSite: {
            site: string
            avgTime: number
          }
          dayDifference: {
            totalFirstDiff: number
            totalLastDiff: number
            count: number
          }
          impressionRangeCounts: Array<{
            range: string
            count: number
          }>
          impressionDecayAnalysis: Array<{
            range: string
            count: number
          }>
        }
      }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/performance/sale-paths/impressions`,
        method: 'GET',
        params: {
          ...queryParams,
        },
      }),
    {
      enabled: !!dealership && !!queryParams?.goal,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  )
}
